import { ValidReportStatus } from '@components/Stats/slice/schemas/schema';

export * from './slice/api';
export * from './components';
export * from './domain';

const approvedStatuses = new Set<ValidReportStatus>([
  'approved',
  'approved_visit_metrics',
]);

export const isApproved = (status: ValidReportStatus) =>
  approvedStatuses.has(status);
